var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88138 6.39224V10.4839C8.88138 10.873 9.09264 11.24 9.42619 11.4401L12.8952 13.497C13.2955 13.7305 13.8069 13.5971 14.0404 13.208C14.2739 12.8077 14.1516 12.2962 13.7513 12.0627L10.5603 10.1615V6.38112C10.5492 5.93638 10.1711 5.55834 9.71528 5.55834C9.25942 5.55834 8.88138 5.93638 8.88138 6.39224ZM20 7.22614V1.34439C20 0.844049 19.3996 0.599439 19.0549 0.955235L17.0758 2.93435C16.0343 1.89277 14.7759 1.09369 13.3903 0.594018C12.0046 0.0943453 10.5259 -0.0936208 9.05928 0.0435087C4.40058 0.466016 0.564657 4.21299 0.0532004 8.87169C-0.217158 11.4839 0.550184 14.0976 2.18969 16.1491C3.82919 18.2006 6.20944 19.5254 8.81694 19.8376C11.4244 20.1499 14.0502 19.4246 16.1277 17.8183C18.2053 16.2119 19.5681 13.8532 19.9222 11.2511C20 10.584 19.4774 10.0058 18.8103 10.0058C18.2544 10.0058 17.7874 10.4172 17.7207 10.962C17.2426 14.8424 13.8959 17.8444 9.88206 17.7888C5.75705 17.7332 2.27692 14.2531 2.21021 10.117C2.1435 5.78072 5.6681 2.22276 9.99324 2.22276C12.1391 2.22276 14.0849 3.10113 15.497 4.50207L13.1732 6.82587C12.8174 7.18166 13.062 7.78207 13.5623 7.78207H19.4441C19.7554 7.78207 20 7.53746 20 7.22614Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummertime);
export default __webpack_public_path__ + "static/media/Summertime.e125b34030066bf934b27f40e535a269.svg";
export { ForwardRef as ReactComponent };